/**
 * # Passive Events
 * Detect whether passive events are supported by a browser
 * Adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 *
 *
 * @module helpers/util/passive-events.js
 */

function supportsPassiveEvents() {
  let supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function() {
        supportsPassive = true;
        return false;
      }
    });

    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    // Catch errors
  }

  return supportsPassive;
}

export default supportsPassiveEvents;
